<template>
  <div>
    <div>
      <button type="button" @click="showMapChooser" class="btn btn-select-map"
              v-bind:class="{ choose_map_active: ChooseMapActive }"
      >
        <v-icon class='v-ion-abn' name='map-pin'></v-icon> Select Map
      </button>
    </div>

    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="1000"
      @cancel="handleCancel"
      @before-close="handleCloseModal"
      :clickToClose="true"
      :reset="true"
      class="Modal_map_box"
      v-bind:class="{active: showModalMap}"
    >
      <div @click="hideSearchMap" class="Abn-modal-close">&#10005;</div>
      <div class="Abn-modal-content Abn-modal-map">

        <div class="Abn-modal-header">
          <h6 class="Abn-modal-title">Search location:</h6>
        </div>


        <div class="Abn-modal-body" ref='map_group_x'>
          <div class="input-group">
            <gmap-autocomplete 
              placeholder="Enter the location" 
              class="Abn-form-search-map"
              @place_changed="initMarker"
              :options="{fields: ['geometry', 'formatted_address', 'address_components']}"
            >
            </gmap-autocomplete>
          </div>
          <div class="Abn-map-box" :style="`width: ${widthShape};height: ${HeightShape}`" ref='map_group'>
            <gmap-map
              class='abn_container_map_html'
              @center_changed="onLoad"
              @drag="onLoad"
              @tilesloaded="onLoad"
              @tilt_changed="onLoad"
              @zoom_changed="ChangeZoom"
              :zoom=MapZoom
              :center="center"
              :map-type-id="mapTypeId"
              ref="mapBoxContainer"
              id='containermap'
              :options="{
             zoomControl: false,
             mapTypeControl: false,
             scaleControl: false,
             streetViewControl: false,
             rotateControl: false,
             fullscreenControl: false,
             disableDefaultUI: false,
             styles: StyleMap
           }"
            >
              <gmap-marker
                v-if='makerstatus'
                class='gmapmarker'
                :position="centerMarker"
                :draggable="true"
                @drag="mouseleaveMarker"
                :icon="{
                url: iconMarkerImg,
                size: {width: 64, height: 64, f: 'px', b: 'px',},
                scaledSize: {width: 64, height: 64, f: 'px', b: 'px',},
                }"
              ></gmap-marker>
            </gmap-map>
            <img draggable="false" ondragstart="return false;" class="box_shape_map" :src="SrcShapeUrl">
          </div>
        </div>

        <div class="Abn-modal-footer">
          <button type="button" @click="hideSearchMap" class="btn Abn-btn-cancel">Cancel</button>
          <button type="button" @click="ApplyMapSearch" class="btn Abn-btn-apply">Apply</button>
        </div>
      </div>

    </modal>

  </div>
</template>

<script>

import axios from 'axios'
import html2canvas from 'html2canvas';
import { ASSET_URL, KEY_API_GOOGLE_MAP, URL_API_IMAGE_SHAPE, URL_API_FILL_IMAGES_SHAPE } from '@/config.js'
import jQuery from 'jquery'
import { mapGetters, mapMutations } from 'vuex'
import {get} from 'lodash'

export default {
  data(){
    return{
      center: this.defaultCenterMap,
      centerChange: this.defaultCenterMap,
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null,
      messageLoading: false,
      SrcShapeUrl: null,
      iconMarkerImg: "https://d1fajaoulwx0c1.cloudfront.net/themes/hellomap-retro-withname-1812/images/159186440762859tgn.png",
      MapZoom: this.defaultZoomMap,
      mapTypeId: "roadmap",
      centerMarker: this.defaultCenterMarker,
      centerMarkerChange: this.defaultCenterMarker,
      ApiKeyMap: KEY_API_GOOGLE_MAP,
      ChooseMapActive: false,
      StyleMap: [],
      widthShape: "100%",
      HeightShape: "500px",
      formattedAddress: null,
      formattedCoordinates: null,
      showModalMap: false
    }
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    layerWidth: {
      type: Number,
      default() {
        return 700
      }
    },
    layerHeight: {
      type: Number,
      default(){
        return 700
      }
    },
    markericon: {
      type: String,
      default(){
        return "bf82f6cc-7737-11ec-8a9d-267b280bfd39__159186440762859tgn.png"
      }
    },
    typemap: {
      type: String,
      default(){
        return "roadmap"
      }
    },
    shapes:{
      type: String,
      default(){
        return "5c78c2d6-773a-11ec-8a9d-267b280bfd39__Shape_700.png"
      }
    },
    typecustom: {
      type: Boolean,
      default(){
        return false
      }
    },
    dataTypeCustom: {
      type: Object,
      default(){
        return {}
      }
    },
    typeMapCustom: {
      type: String,
      default(){
        return null
      }
    },
    makerstatus: {
      type: Boolean,
      default(){
        return false
      }
    },
    jsonDataMap: {
      type: Array,
      default(){
        return []
      }
    },
    defaultCenterMap: {
      type: Object,
      default(){
        return {
          lat: 29.95106579999999,
          lng: -90.0715323
        }
      }
    },
    defaultCenterMarker: {
      type: Object,
      default() {
        return {
          lat: 29.95106579999999,
          lng: -90.0715323
        }
      }
    },
    defaultZoomMap: {
      type: Number,
      default() {
        return 12;
      }
    },
    MapIdParent: {
      type: String,
      default() {
        return null;
      }
    }
  },
  mounted(){
    this.$modal.show(this.modalName);
    const OnThis = this;
    const info_shape = this.getMetaIMG(this.SrcShapeUrl);
    
    const s = setTimeout(function(){ 
      const map_group = OnThis.$refs.map_group;
      const width_box = map_group.offsetWidth;
      // path.width : x = 570
      const x = info_shape.width / width_box;
      const width = info_shape.width / x;
      const height = info_shape.height / x;
      OnThis.widthShape = `${width}px`;
      OnThis.HeightShape = `${height}px`;

      info_shape.width = `${width}px`;
      info_shape.height = `${height}px`;
      clearTimeout(s);
    }, 900)
  },
  created() {
    this.$modal.show(this.modalName);
    this.SrcShapeUrl = this.shapes;
    this.iconMarkerImg = ASSET_URL + '/' + this.markericon;
    this.StyleMap = this.jsonDataMap;
    this.mapTypeId = this.typemap;
  },
  computed:{
    modalName() {
      return `map-${this.uniqueID(10)}`
    },
    localStorageName(){
      return this.context.name + '_' + this.product().id;
    }
  },
  methods: {
    ...mapGetters([
      'product',
      'platform',
      'getCartData',
      'artworks',
      'personalized',
      'isSaveLocalstorage'
    ]),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    googleStaticMapsStylerQuery(styles) {
      let query = "";
      for (const style of styles) {
        const component = [];
        if (style.featureType) component.push("feature:" + style.featureType);
        if (style.elementType) component.push("element:" + style.elementType);
        for (const rule of /** @type {Array<{ [key: string]: unknown }>} */ (
          style.stylers
        )) {
          const [name] = Object.keys(rule);
          const value = String(rule[name]).replace("#", "0x");
          component.push(`${name}:${value}`);
        }
        query += "&style=" + encodeURIComponent(component.join("|"));
      }
      return query;
    },
    async showMapChooser(e) {
      e.preventDefault();
      const ThisHere = this;
      this.$modal.show(this.modalName);
      setTimeout(() => {
        this.showModalMap = true;
        if(ThisHere.$refs.mapBoxContainer.$el.querySelector('.gmnoprint.gm-style-cc')){
          ThisHere.$refs.mapBoxContainer.$el.querySelector('.gmnoprint.gm-style-cc').parentElement.style.display = "none";
        }

        if(ThisHere.$refs.mapBoxContainer.$el.querySelector("a[rel='noopener']")){
          ThisHere.$refs.mapBoxContainer.$el.querySelector("a[rel='noopener']").style.display = "none";
        }
      }, 100);      
    },
    getMetaIMG(url) {
      let img = new Image();
      img.src = url;
      var v = img.onload = function(){
        var imgs = img;
        return imgs;
      }();
      return v;
    },
    ChangeZoom(zoom){
      this.MapZoom = zoom;
    },
    onLoad(data){
      if(typeof data == 'object'){
        const dataEx = JSON.parse(JSON.stringify(data))
        // .log(dataEx)
        this.centerChange = {
          lat: dataEx.lat,
          lng: dataEx.lng
        }
        this.setFormattedCoordinates();
      }
    },
    mouseleaveMarker(data){
      if(typeof data == 'object'){
        const dataEx = JSON.parse(JSON.stringify(data))
        this.centerMarkerChange = {
          lat: data.latLng.lat(),
          lng: data.latLng.lng()
        }
        this.setFormattedCoordinates();
      }
    },
    setFormattedCoordinates(){
      if(this.makerstatus){
        this.formattedCoordinates = this.renderCoordinatesMap(this.centerMarkerChange.lat, this.centerMarkerChange.lng);
      }else {
        this.formattedCoordinates = this.renderCoordinatesMap(this.centerChange.lat, this.centerChange.lng);
      }
    },
    hideModal(e) {
      e.preventDefault()
      this.showModalMap = false;
      // this.$modal.hide(this.modalName)
    },
    handleCloseModal(){
      this.showModalMap = false;
    },
    hideSearchMap(e){
      e.preventDefault()
      this.showModalMap = false;
      // this.$modal.hide(this.modalName);
    },
    initMarker(loc) {
      this.existingPlace = loc;
      this.center = {
        lat: loc.geometry.location.lat(),
        lng: loc.geometry.location.lng()
      }

      this.centerMarker = {
        lat: loc.geometry.location.lat(),
        lng: loc.geometry.location.lng()
      }

      this.formattedAddress = loc.formatted_address;
      this.centerChange = this.center
      this.centerMarkerChange = this.centerMarker
      this.setFormattedCoordinates();
    },
    renderCoordinatesMap(lat, lng){
      let iconLat = Number(lat) < 0 ? 'S' : 'N';
      let iconLng = Number(lng) < 0 ? 'W' : 'E';
      return Math.abs(lat).toFixed(4) + '° ' + iconLat + ', ' + Math.abs(lng).toFixed(4)  + '° ' + iconLng;
    },
    async ApplyMapSearch(e) {
      e.preventDefault()
      this.setLoadingForm(true)

      const datamap = JSON.parse(JSON.stringify(this.centerChange))
      const Maplat = datamap.lat
      const Maplng = datamap.lng

      const dataMarker = JSON.parse(JSON.stringify(this.centerMarkerChange))
      const Markerlat = dataMarker.lat
      const Markerlng = dataMarker.lng

      const MakerIcon = encodeURIComponent(this.iconMarkerImg)

      const DomCanvas = jQuery('#containermap')

      var Width = 1000
      var Height = 1000

      if(DomCanvas.length){
        Width =  DomCanvas[0].offsetWidth
        Height = DomCanvas[0].offsetHeight
      }

      var StringMarker
      if(this.makerstatus){
        StringMarker = `&markers=icon:${MakerIcon}|${Markerlat},${Markerlng}`
      }else {
        StringMarker = ``
      }

      const v_scale = "2";

      var Link = this.JsonToMap(Maplat,Maplng, this.MapZoom,this.mapTypeId, Width, Height, StringMarker, this.jsonDataMap);

      const UploadFile = await this.upload(Link);
      if(UploadFile.status){
        this.setCartDataByKey({
          key: this.localStorageName,
          name: this.context.label,
          value: ASSET_URL + '/' + UploadFile.key
        });
        try{
          const ImageShapeRawResponse = await fetch(URL_API_IMAGE_SHAPE, {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            urlShape : this.SrcShapeUrl,
            urlImages: ASSET_URL + '/' + UploadFile.key
          })
        });
        const contentCanvas = await ImageShapeRawResponse.json();
        var file = {
          id: this.context.name,
          key: contentCanvas.key
        }
        this.setIsSaveLocalstorage(true);
        this.context.model = file

        this.ChooseMapActive = true

        this.showModalMap = false;
        // this.$modal.hide(this.modalName);
        const dEvent = {
          id: this.MapIdParent,
          Coordinates: this.formattedCoordinates,
          Location: this.formattedAddress
        }

        this.$emit('ChangeTextMapChild', dEvent);

        this.center = this.centerChange
        this.centerMarker = this.centerMarkerChange        
        }catch(err){
          this.setLoadingForm(false)
          this.setMessageError(true);
        }        
      }
      this.setLoadingForm(false)
    },
    JsonToMap(lat,lng,zoom,type_id,width,height,marker,json){
      const v_scale = "2";
      const stringBefore = `https://maps.googleapis.com/maps/api/staticmap?key=${this.ApiKeyMap}&center=${lat},${lng}&zoom=${zoom}&format=png${marker}&maptype=${type_id}&size=${width}x${height}&scale=${v_scale}`;
      const StringJson = this.googleStaticMapsStylerQuery(json);
      const link = stringBefore + StringJson;
      return link;
    },
    handleCancel(e) {
      e.preventDefault()
      this.showModalMap = false;
      // this.$modal.hide(this.modalName)
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      const put = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if(put.status === 200){
        return {
          status: true,
          key: signedUrl.key
        }
      }else {
        return {
          status: false
        }
      }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>

<style>
div#containermap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  overflow: no-content;
}

.Modal_map_box > div{
  overflow: auto !important;
  max-width: 100%;
}

.Modal_map_box .vm--overlay{
  display: none !important;
}

.Modal_map_box.active .vm--overlay{
  display: block !important;
}

.Abn-modal-map{
  overflow: auto;
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
}

.Abn-modal-close {
  background: #6e6e6f;
  width: 50px;
  height: 50px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.Modal_map_box{
  height: 99vh !important;
}

.Modal_map_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.Modal_map_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

@media only screen and (max-width: 739px){
  .Abn-modal-content{
    padding-top: 35px !important
  }

  .Modal_map_box > div{
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
  }
}
</style>

<style scoped>
input[type='file'] {
  display: none;
}

.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

.copper-wrapper {
  display: grid;
  grid-template-columns: auto 120px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 40px;
}
.modal-wrapper .cropper-wrapper {
  overflow: auto;
}


.Abn-modal-content{
  padding: 15px;
}

.mapboxgl-map{
  overflow: auto !important;
}
.Abn-map-box{
  position: relative;
  margin-top: 7px ;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

/*.Abn-map-box:after {*/
/*  content: "";*/
/*  display: block;*/
/*  padding-bottom: 100%;*/
/*}*/

.box_shape_map{
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0.6;
  opacity: 0.7;
  position: absolute;
  top: 0;
  bottom: 0;
}

.box_list_map li:hover{
  color: #018f96;
}

.box_list_map li{
  padding: 5px;
  margin: 3px 0;
  cursor: pointer;
}

.box_list_map input[type=radio]{
  display: none;
}

.box_list_map input[type=radio]:checked ~ label{
  color: #f6f6f6;
  background: none 0% 0% / auto repeat scroll padding-box border-box #dc3545;
  width: 99% !important;
  padding: 5px !important;
  border-radius: 3px !important;
}

.box_list_map input[type=radio]:checked ~ label::before{
  content: '\2762 ' !important;
}


.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 99999999999 !important;
}

img.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid #5c6ac4;
  cursor: pointer;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}


.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Abn-modal-body{
  position: relative;
}

.box_list_map{
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
  background: white;
  border: 1px solid #484747;
  margin-top: 5px;
  border-radius: 5px;
}

.Abn-modal-footer{
  display: flex;
  margin-top: 7px;
  justify-content: space-between;
}
button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
  margin: 0px !important;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
  margin: 0px !important;
}

.mapboxgl-ctrl-logo{
  display: none !important;
}

.mapboxgl-ctrl-bottom-left {
  display: none !important;
}

.Modal_map_box{
  overflow: auto !important;
  max-width: 100%;
  top: 5px;
  bottom: 5px;
  top: +100vh;
  transition: 0.7s;
}

.Modal_map_box.active{
  display: block;
  transition: 0.7s;
  top: 0;
}

.Abn-form-search-map{
  width: 100%;
  outline: none;
  padding: 7px;
  border: 2px solid #66666a;
  border-radius: 5px;
  transition: 0.7s;
}
.Abn-form-search-map:focus{
  border: 2px solid  #9e0000;
}


.Abn-modal-title{
  margin-bottom: 10px;
}

.v-ion-abn{
  width: 16px;
  padding: 0;
  margin: 0;
}


.choose_map_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}


@keyframes animation_button_active {
  from {opacity: 0.1;}
  to {opacity: 1;}
}

.gmnoprint{
  display: none !important;
}

.Abn-modal-footer {
  position: sticky;
  bottom: 0;
  width: 570px;
  margin: auto;
  max-width: 100%;
  background: #ffffff66;
  padding: 5px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageMap.vue